console.log("ok.js here");
// var x = function () {
//     alert("works");
//     console.log(this.parentElement);
// }

function copyMethod(text) {
           // alert("hello world" + text);
            // var div = document.createElement("span");
            // div.className = "thx";
            // div.style.opacity = 0;
            // div.getAttribute("title","notify");

            var tthx = document.querySelector(".adkar.windows").querySelector(".thx");
            // var tthx = document.querySelector(".thx");
            tthx.innerText = text;
            tthx.style.opacity = 1;
            tthx.style.top = "10%";
            setTimeout(function () {
                tthx.style.opacity = 0;
                tthx.style.top = "5%";
                // document.querySelector(".thx").remove();
            }, 2000);
        }

// shareUsCopy();
// function shareUsCopy() {
//     var data = "لا تنسى زيارة موقعنا للمزيد من الأذكار" + "   \n" + location.href;
//         var txtArea = document.createElement("textarea");
//             txtArea.width = "1px";
//             txtArea.height = "1px";
//             txtArea.background = "transparent";
//             txtArea.value = data;
//             document.body.append(txtArea);
//             txtArea.select();
//             document.execCommand("copy");
//             document.body.removeChild(txtArea);

//             document.querySelector(".settings .layer.shareUs .card button").click();
//         copyMethod("تم نسخ النص إلى الحافظة");
// }

export function copyShare() {document.querySelectorAll(".copy-class").forEach(el => {
    el.addEventListener("click", () => {
        var title = el.parentElement.parentElement.parentElement.querySelector("h2").innerText,
            text = el.parentElement.parentElement.querySelector("p").innerText,
            correction = el.parentElement.parentElement.querySelectorAll("span")[0].innerText,
            correction2 = el.parentElement.parentElement.querySelectorAll("span")[1].innerText;
        var data = `${title} \n ${text} \n ${correction}  -  ${correction2}`;
            data += "\n" + "لا تنسى زيارة موقعنا للمزيد من الأذكار" + "   " + location.href;
        var txtArea = document.createElement("textarea");
            txtArea.width = "1px";
            txtArea.height = "1px";
            txtArea.background = "transparent";
            txtArea.value = data;
            document.body.append(txtArea);
            txtArea.select();
            document.execCommand("copy");
            document.body.removeChild(txtArea);

        copyMethod("تم نسخ النص إلى الحافظة");
    });

});}
//  twitter
// export function twitterShare() {document.querySelectorAll(".post-twitter").forEach(el => {
//     twitterEl.addEventListener("click", function(){});
// // export const twitterPost = function() {
//     console.log(this.parentElement);
//         var title = this.parentElement.parentElement.parentElement.querySelector("h2").innerText,
//             text = this.parentElement.parentElement.querySelector("p").innerText,
//             correction = this.parentElement.parentElement.querySelectorAll("span")[0].innerText,
//             correction2 = this.parentElement.parentElement.querySelectorAll("span")[1].innerText;
//         var data = `[ ${title} ]    ${text}    ${correction}  -  ${correction2}  `;
//             data += "قم بزيارة موقعنا للمزيد من الأذكار   " + location.href; 
//         window.open(`https://twitter.com/intent/tweet?text=${data}`, "_blank");
    

// });}
// twitter
export function twitterShare(){ document.querySelectorAll(".post-twitter").forEach(twitterEl => {
    twitterEl.addEventListener("click", () => {
        var title = twitterEl.parentElement.parentElement.parentElement.querySelector("h2").innerText,
            text = twitterEl.parentElement.parentElement.querySelector("p").innerText,
            correction = twitterEl.parentElement.parentElement.querySelectorAll("span")[0].innerText,
            correction2 = twitterEl.parentElement.parentElement.querySelectorAll("span")[1].innerText;
        var data = `[ ${title} ]    ${text}    ${correction}  -  ${correction2}  `;
            data += "قم بزيارة موقعنا للمزيد من الأذكار  " + location.href; 
        window.open(`https://twitter.com/intent/tweet?text=${data}`, "_blank");
    });

});}
// tele
export function teleShare(){ document.querySelectorAll(".share-telegram").forEach(teleEl => {
    teleEl.addEventListener("click", () => {
        var title = teleEl.parentElement.parentElement.parentElement.querySelector("h2").innerText,
            text = teleEl.parentElement.parentElement.querySelector("p").innerText,
            correction = teleEl.parentElement.parentElement.querySelectorAll("span")[0].innerText,
            correction2 = teleEl.parentElement.parentElement.querySelectorAll("span")[1].innerText;
        var data = `[ ${title} ]    ${text}    ${correction}  -  ${correction2}  `;
            data += "قم بزيارة موقعنا للمزيد من الأذكار  " + location.href; 
        window.open(`https://telegram.me/share/url?url=${data}`, "_blank");
    });

});}
//  wa
export function waShare() {document.querySelectorAll(".share-wa").forEach(waEl => {
    waEl.addEventListener("click", () => {
        var title = waEl.parentElement.parentElement.parentElement.querySelector("h2").innerText,
            text = waEl.parentElement.parentElement.querySelector("p").innerText,
            correction = waEl.parentElement.parentElement.querySelectorAll("span")[0].innerText,
            correction2 = waEl.parentElement.parentElement.querySelectorAll("span")[1].innerText;
        var data = `[%20*${title}*%20]%20%20%20%20${text}%20%20%20%20_${correction}%20%20-%20%20${correction2}_  `;
            data += "قم بزيارة موقعنا للمزيد من الأذكار" + "   " + location.href; 
        window.open(`https://api.whatsapp.com/send?text=${data}`, "_blank");
    });
});}